var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.727 26.79c-.275.144-.553.21-.729.21s-.44-.055-.725-.21C9.123 23.304 7 21.843 7 17.87V9.526c0-1.14.496-1.516 1.408-1.892 1.289-.52 5.404-2.059 6.689-2.48.285-.088.595-.154.901-.154.31 0 .616.055.916.155 1.274.443 5.39 1.948 6.678 2.479.922.387 1.408.752 1.408 1.892v8.344c0 3.973-2.014 5.622-8.273 8.92zm-2.96-6.33c.286.387.594.53.968.53s.693-.176.924-.53l5.17-8.2c.142-.222.274-.476.274-.73 0-.51-.45-.842-.924-.842-.297 0-.582.166-.791.51l-4.697 7.59-2.233-2.899c-.275-.365-.517-.476-.825-.476-.506 0-.89.41-.89.919 0 .244.098.498.263.72z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/Shield_Check.6d78f1f140edc82e5bf2ac97c65cde7d.svg";
export { ForwardRef as ReactComponent };